import { useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';

const toInputValue = (date: Date | null): string => {
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const fromInputValue = (value: string): Date | null => {
  if (!value) return null;
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
};

interface DateFilterSingleProps {
  selectsRange?: false;
  selected: Date | null;
  onChange: (date: Date | null) => void;
  native?: boolean;
}

interface DateFilterRangeProps {
  selectsRange: true;
  startDate: Date | null;
  endDate: Date | null;
  onChange: (range: [Date | null, Date | null]) => void;
  native?: boolean;
}

export type DateFilterProps = DateFilterSingleProps | DateFilterRangeProps;

const NativeDateInput = ({
  value,
  onChange,
}: {
  value: Date | null;
  onChange: (date: Date | null) => void;
}) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) ref.current.value = toInputValue(value);
  }, [value]);

  return (
    <input
      type="date"
      ref={ref}
      defaultValue={toInputValue(value)}
      onChange={(e) => {
        if (!e.target.value) {
          onChange(null);
          return;
        }
        if (parseInt(e.target.value.split('-')[0], 10) >= 1000)
          onChange(fromInputValue(e.target.value));
      }}
    />
  );
};

export const DateFilter = (props: DateFilterProps) => {
  if (props.selectsRange) {
    if (props.native) {
      return (
        <div className="date-filter-native">
          <NativeDateInput
            value={props.startDate}
            onChange={(date) => props.onChange([date, props.endDate])}
          />
          <NativeDateInput
            value={props.endDate}
            onChange={(date) => props.onChange([props.startDate, date])}
          />
        </div>
      );
    }
    return (
      <DatePicker
        inline
        selectsRange
        startDate={props.startDate ?? undefined}
        endDate={props.endDate ?? undefined}
        onChange={(range) => props.onChange(range)}
      />
    );
  }

  if (props.native) {
    return (
      <div className="date-filter-native">
        <NativeDateInput value={props.selected} onChange={props.onChange} />
      </div>
    );
  }

  return (
    <DatePicker
      inline
      selected={props.selected ?? undefined}
      onChange={(date) => props.onChange(date)}
    />
  );
};
